module.exports = __webpack_public_path__ + "img/view.75ba8836.svg";